import React from 'react';
import { Box, Typography, Chip } from '@mui/material';
import { upperFirst } from 'lodash';
import { AppRelease, ReleaseType } from 'commons/interfaces';
interface SystemVersionProps {
  newsUpdated: AppRelease | null;
  handleViewNovedades: () => void;
}

const translateType = (type?: ReleaseType | string) => {
  switch (type?.toUpperCase()) {
    case 'MAJOR':
      return 'Actualización Mayor';
    case 'MINOR':
      return 'Nuevas Mejoras';
    case 'PATCH':
      return 'Correcciones';
    default:
      return 'Actualización';
  }
};

const getTypeStyles = (type?: ReleaseType | string) => {
  switch (type?.toUpperCase()) {
    case 'PATCH':
      return {
        color: '#2E7D32',
        backgroundColor: '#E8F5E9',
      };

    case 'MINOR':
      return {
        color: '#1976D2',
        backgroundColor: '#E3F2FD',
      };

    case 'MAJOR':
      return {
        color: '#ED6C02',
        backgroundColor: '#FFF3E0',
      };

    default:
      return {
        color: '#424242',
        backgroundColor: '#F5F5F5',
      };
  }
};

export const SystemVersion: React.FC<SystemVersionProps> = ({
  newsUpdated,
  handleViewNovedades,
}) => {
  return (
    <Box sx={{ p: 2, mt: 'auto' }}>
      <Box
        sx={{
          p: 2,
          borderRadius: 3,
          border: '1px solid',
          borderColor: 'divider',
          bgcolor: 'background.paper',
          display: 'flex',
          flexDirection: 'column',
          gap: 0.5,
        }}
      >
        <Box display="flex" alignItems="center" gap={1} mb={0.5}>
          <Typography variant="subtitle2" fontWeight="bold" color="text.primary">
            {upperFirst(newsUpdated?.application?.name || 'QiHotels')}
          </Typography>
          <Box
            sx={{
              bgcolor: '#634bde',
              color: 'white',
              px: 0.8,
              py: 0.2,
              borderRadius: 1,
              fontSize: '0.65rem',
              fontWeight: 'bold',
            }}
          >
            v{newsUpdated?.version || '2.4.1'}
          </Box>
        </Box>

        <Chip
          label={translateType(newsUpdated?.type)}
          size="small"
          sx={{
            ...getTypeStyles(newsUpdated?.type),
            fontWeight: 'bold',
            alignSelf: 'flex-start',
            mb: 0.5,
          }}
        />
        <Typography variant="caption" color="text.secondary">
          Build {newsUpdated?.version || '220526'}
        </Typography>

        <Box display="flex" alignItems="center" gap={0.5} mt={0.5}>
          <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: '#34A853' }} />
          <Typography variant="caption" sx={{ color: '#34A853', fontWeight: '500' }}>
            Sistema estable
          </Typography>
        </Box>

        <Typography
          variant="caption"
          onClick={handleViewNovedades}
          sx={{
            color: '#634bde',
            fontWeight: 'bold',
            mt: 1,
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: 0.5,
            '&:hover': { textDecoration: 'underline' },
          }}
        >
          Ver novedades
          <svg
            width="12"
            height="12"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
            <polyline points="15 3 21 3 21 9"></polyline>
            <line x1="10" y1="14" x2="21" y2="3"></line>
          </svg>
        </Typography>
      </Box>
    </Box>
  );
};
